import React from "react";
import type { LearningModule } from "./types";

type ModuleStatisticsProps = {
  module: LearningModule;
  createdDate?: string;
  modifiedDate?: string;
};

export default function ModuleStatistics({ module, createdDate, modifiedDate }: ModuleStatisticsProps) {
  // Calculate statistics
  const chapterCount = module.groups.length;
  const sectionCount = module.groups.reduce((acc, group) => acc + group.steps.length, 0);
  const resourceCount = module.groups.reduce(
    (acc, group) => acc + group.steps.reduce((stepAcc, step) => stepAcc + step.resources.length, 0),
    0
  );

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return "N/A";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
    } catch {
      return "N/A";
    }
  };

  return (
    <div className="lmb-card">
      <div className="lmb-card-hd">
        <div><strong>📊 Module Statistics</strong></div>
      </div>
      <div className="lmb-card-bd">
        <div className="lmb-stats-grid">
          <div className="lmb-stat-item">
            <div className="lmb-stat-icon">📚</div>
            <div className="lmb-stat-content">
              <div className="lmb-stat-value">{chapterCount}</div>
              <div className="lmb-stat-label">Chapter{chapterCount !== 1 ? "s" : ""}</div>
            </div>
          </div>

          <div className="lmb-stat-item">
            <div className="lmb-stat-icon">📄</div>
            <div className="lmb-stat-content">
              <div className="lmb-stat-value">{sectionCount}</div>
              <div className="lmb-stat-label">Section{sectionCount !== 1 ? "s" : ""}</div>
            </div>
          </div>

          <div className="lmb-stat-item">
            <div className="lmb-stat-icon">📎</div>
            <div className="lmb-stat-content">
              <div className="lmb-stat-value">{resourceCount}</div>
              <div className="lmb-stat-label">Resource{resourceCount !== 1 ? "s" : ""}</div>
            </div>
          </div>
        </div>

        <div className="lmb-hr" style={{ margin: "12px 0" }}></div>

        <div className="lmb-stat-details">
          <div className="lmb-stat-row">
            <span className="lmb-muted">📅 Created:</span>
            <span>{formatDate(createdDate)}</span>
          </div>
          <div className="lmb-stat-row">
            <span className="lmb-muted">✏️ Modified:</span>
            <span>{formatDate(modifiedDate)}</span>
          </div>
          {module.id && (
            <div className="lmb-stat-row">
              <span className="lmb-muted">🏷️ Module ID:</span>
              <span>{module.id}</span>
            </div>
          )}
          <div className="lmb-stat-row">
            <span className="lmb-muted">Status:</span>
            <span className={`lmb-status-badge ${module.status === 1 ? "active" : "inactive"}`}>
              {module.status === 1 ? "Active" : "Inactive"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
